import styled from "styled-components";

export const ImageContainer = styled.img `
    filter: drop-shadow(0 0 1rem purple);
    width:100% ;
    height:100% ;
`